import { store, EVENT_APP_READY } from '@/main'
import EventBus from 'CORE/bus'

export const appReady = _ => {
    return new Promise((resolve, reject) => {
        if (store.getters.appReady) {
            resolve(store.getters.readyTime)
        } else {
            EventBus.$on(EVENT_APP_READY, _ => {
                resolve(0)
            })
        }
    })
}

export default appReady
